import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

const ProjectTypesOverview: React.FC<HTMLAttributes<HTMLDivElement>> = () => (
  <div className="Paragraph ParagraphProjectsOverview">
    <Container>
      <View
        id="project_types"
        display="default"
      />
    </Container>
  </div>
);

export default ProjectTypesOverview;
